import { Globals } from "../CoreApp/Globals";
import { ubtoa } from "./ubtoa";

export function getsessioncounter() {
  var val = Math.floor(1000 + Math.random() * 9000);
  val = val.toString() + "." + Globals._sessionCounter.toString();
  val = ubtoa(val);
  return val;
}
